<app-menu></app-menu>
<router-outlet></router-outlet>
<app-rodape></app-rodape>
